import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-search-box',
  imports: [CommonModule],
  templateUrl: './search-box.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class SearchBoxComponent {

  @Input() value = '';
  @Input() placeholder = '';
  @Input() ariaLabel?: string;
  @Input() className = '';

  @Output() valueChange = new EventEmitter<string>();

  get inputAriaLabel(): string {
    return this.ariaLabel || this.placeholder;
  }

  onInput(event: Event): void {
    this.valueChange.emit((event.target as HTMLInputElement).value);
  }

  onClear(): void {
    this.value = '';
    this.valueChange.emit('');
  }
}
